export const translations = {
  id: {
    nav: { brands: "Merek Kami", about: "Tentang", certs: "Sertifikasi", contact: "Kontak", requestQuote: "Ajukan Permintaan" },
    common: {
      since: "Sejak 1976",
      readMore: "Selengkapnya",
      viewBrand: "Lihat Merek",
      requestSample: "Minta Sampel",
      distributorInquiry: "Pertanyaan Distributor",
      application: "Aplikasi",
      packaging: "Kemasan",
      size: "Ukuran",
      type: "Jenis",
      segment: "Segmen",
      retail: "Ritel",
      industrial: "Industri",
      shelfLife: "Masa Simpan",
      storage: "Penyimpanan",
      allProducts: "Semua Produk",
      backTo: "Kembali ke",
      downloadSpec: "Unduh Lembar Spesifikasi",
      exploreBrands: "Jelajahi Merek Kami",
    },
    home: {
      heroKicker: "Produsen Bahan Kue Indonesia",
      heroLine1: "The Baking",
      heroLine2: "Company.",
      heroSub: "Sejak 1976, kami meracik bahan-bahan yang menghidupkan dapur Indonesia — dari rumah tangga hingga produsen kelas dunia.",
      trustTitle: "Dipercaya & Bersertifikat",
      brandsTitle: "Satu Rumah, Lima Merek",
      brandsSub: "Setiap merek melayani kebutuhan yang berbeda — dengan standar kualitas yang sama.",
      whyTitle: "Mengapa Memilih Kami",
      snapshotTitle: "Sekilas Perusahaan",
      ctaTitle: "Ceritakan apa yang Anda buat.",
      ctaSub: "Sampaikan spesifikasi, aplikasi, dan volume Anda — kami akan membalas dengan sampel.",
    },
    about: {
      title: "Warisan yang Terus Berkembang",
      intro: "Berawal sebagai industri rumahan pada tahun 1976, PT Tan Putra Tama telah tumbuh menjadi produsen bahan kue tepercaya di Indonesia.",
      missionTitle: "Misi Kami",
      mission: "Menyediakan bahan kue berkualitas tinggi yang konsisten dan andal bagi setiap dapur — dari rumah tangga hingga industri.",
      sustainTitle: "Komitmen Keberlanjutan",
      segmentsTitle: "Pelanggan Kami",
    },
    contact: {
      title: "Mari Terhubung",
      sub: "Dua jalur pertanyaan untuk memastikan permintaan Anda sampai ke tim yang tepat.",
      tabGeneral: "Distributor / Umum (ID)",
      tabExport: "Ekspor / Clara (EN)",
      name: "Nama", company: "Perusahaan", email: "Email", phone: "Telepon", country: "Negara",
      brand: "Merek / Produk yang Diminati", volume: "Perkiraan Volume / MOQ", appField: "Aplikasi",
      message: "Pesan", send: "Kirim Pesan", sending: "Mengirim...",
      success: "Terima kasih! Permintaan Anda telah terkirim.",
      error: "Gagal mengirim. Silakan coba lagi.",
      reach: "Hubungi Kami", hours: "Jam Kerja", hoursVal: "Senin – Jumat, 08.00 – 17.00 WIB",
    },
    footer: { tagline: "The Baking Company", rights: "Hak cipta dilindungi.", admin: "Admin" },
  },
  en: {
    nav: { brands: "Our Brands", about: "About", certs: "Certifications", contact: "Contact", requestQuote: "Request a Quote" },
    common: {
      since: "Since 1976",
      readMore: "Read more",
      viewBrand: "View Brand",
      requestSample: "Request a Sample",
      distributorInquiry: "Distributor Inquiry",
      application: "Application",
      packaging: "Packaging",
      size: "Size",
      type: "Type",
      segment: "Segment",
      retail: "Retail",
      industrial: "Industrial",
      shelfLife: "Shelf Life",
      storage: "Storage",
      allProducts: "All Products",
      backTo: "Back to",
      downloadSpec: "Download Spec Sheet",
      exploreBrands: "Explore Our Brands",
    },
    home: {
      heroKicker: "Indonesian Baking-Ingredient Manufacturer",
      heroLine1: "The Baking",
      heroLine2: "Company.",
      heroSub: "Since 1976 we craft the ingredients that bring Indonesian kitchens to life — from households to world-class manufacturers.",
      trustTitle: "Trusted & Certified",
      brandsTitle: "One House, Five Brands",
      brandsSub: "Each brand serves a distinct need — held to the same standard of quality.",
      whyTitle: "Why Choose Us",
      snapshotTitle: "Company Snapshot",
      ctaTitle: "Tell us what you're making.",
      ctaSub: "Reach out with your specification, application and volume — we'll reply with a sample.",
    },
    about: {
      title: "A Heritage Still Rising",
      intro: "Founded as a home industry in 1976, PT Tan Putra Tama has grown into one of Indonesia's most trusted baking-ingredient manufacturers.",
      missionTitle: "Our Mission",
      mission: "To deliver consistent, reliable, high-quality baking ingredients to every kitchen — from households to industry.",
      sustainTitle: "Sustainability Commitment",
      segmentsTitle: "Our Customers",
    },
    contact: {
      title: "Let's Connect",
      sub: "Two inquiry paths so your request reaches the right team, pre-qualified.",
      tabGeneral: "Distributor / General (ID)",
      tabExport: "Export / Clara (EN)",
      name: "Name", company: "Company", email: "Email", phone: "Phone", country: "Country",
      brand: "Brand / Product of Interest", volume: "Estimated Volume / MOQ", appField: "Application",
      message: "Message", send: "Send Message", sending: "Sending...",
      success: "Thank you! Your inquiry has been sent.",
      error: "Failed to send. Please try again.",
      reach: "Reach Us", hours: "Business Hours", hoursVal: "Mon – Fri, 08:00 – 17:00 WIB",
    },
    footer: { tagline: "The Baking Company", rights: "All rights reserved.", admin: "Admin" },
  },
};

export const BRANDS = [
  {
    slug: "claris", name: "Claris", logo: "/logos/claris.png", tagline: { id: "Bahan Kue Ritel", en: "Retail Baking Ingredients" },
    desc: { id: "Gula Halus, Donat, Pengembang dan Meses untuk rumah tangga, bakery dan UMKM.", en: "Icing sugar, donut sugar, cake improvers and sprinkles for households, bakeries and SMEs." },
    accent: "#DA3C30", categories: ["gula", "pengembang", "meses"],
  },
  {
    slug: "clara", name: "Clara", logo: "/logos/clara.png", tagline: { id: "Cokelat Bubuk (B2B/Ekspor)", en: "Cocoa Powder (B2B/Export)" },
    desc: { id: "Cokelat bubuk natural & alkalized untuk importir internasional dan B2B.", en: "Natural & alkalized cocoa powder for international importers and B2B." },
    accent: "#A94438", categories: [],
  },
  {
    slug: "roman", name: "Roman", logo: "/logos/roman.png", tagline: { id: "Pasta & Compound Cokelat", en: "Chocolate Paste & Compound" },
    desc: { id: "Pasta cokelat dan compound serbaguna untuk distributor B2B.", en: "Versatile chocolate paste and compound for B2B distributors." },
    accent: "#3D2314", categories: ["pasta", "compound"],
  },
  {
    slug: "rimbo", name: "Rimbo", logo: "/logos/rimbo.png", tagline: { id: "Pasta & Compound Cokelat", en: "Chocolate Paste & Compound" },
    desc: { id: "Pasta cokelat dan compound serbaguna untuk distributor B2B.", en: "Versatile chocolate paste and compound for B2B distributors." },
    accent: "#3D2314", categories: ["pasta", "compound"],
  },
  {
    slug: "boncoco", name: "Boncoco", logo: "/logos/boncoco.png", tagline: { id: "Pasta Cokelat", en: "Chocolate Paste" },
    desc: { id: "Pasta cokelat serbaguna untuk UMKM, bakery dan B2B.", en: "Versatile chocolate paste for SMEs, bakeries and B2B." },
    accent: "#8A5A34", categories: ["glaze"],
  },
];

export const CERTS = [
  { name: "Halal Indonesia", abbr: "HALAL", logo: "/certs/halal.png", desc: { id: "Bersertifikat Halal MUI/BPJPH — seluruh produk Claris.", en: "Halal-certified by MUI/BPJPH — all Claris products." } },
  { name: "BPOM", abbr: "BPOM", logo: "/certs/bpom.png", desc: { id: "Diawasi dan terdaftar pada Badan POM Indonesia.", en: "Supervised and registered with Indonesia's BPOM." } },
  { name: "ISO 9001:2015", abbr: "ISO", logo: "/certs/iso.png", desc: { id: "Sistem manajemen mutu berstandar internasional.", en: "International quality management system standard." } },
  { name: "ISO 22000", abbr: "ISO22000", logo: "/certs/iso22000.png", desc: { id: "Standar internasional yang menetapkan persyaratan Sistem Manajemen Keamanan Pangan (FSMS).", en: "International standard specifying the requirements for a Food Safety Management System (FSMS)." } },
  { name: "SNI Indonesia", abbr: "SNI", logo: "/certs/sni.png", desc: { id: "Memenuhi Standar Nasional Indonesia.", en: "Compliant with the Indonesian National Standard." } },
];
